import React from 'react'
import { withRouter } from 'react-router-dom'

const BackButton = (props) => {
  return (
    <button
      className="btn edit reverse_primary flex"
      onClick={props.history.goBack}
    >
      <span>戻る</span>
    </button>
  )
}

export default withRouter(BackButton)



// WEBPACK FOOTER //
// ./src/components/_common/BackButton.js